import React, { useMemo, useState } from 'react';
import { useNotification } from '../../contexts/NotificationContext';
import { getApiUrl } from '../../utils/api';

const MoveFoldersModal = ({ isOpen, onClose, onSuccess, folders = [], selectedIds = [] }) => {
  const { showError, showSuccess } = useNotification();
  const [targetFolderId, setTargetFolderId] = useState('');
  const [loading, setLoading] = useState(false);

  const selectedSet = useMemo(() => new Set(selectedIds), [selectedIds]);

  // Pastas selecionadas (e toda a subárvore delas) não podem ser destino —
  // moveria uma pasta pra dentro dela mesma.
  const flatFolders = useMemo(() => {
    const out = [];
    const walk = (nodes, level = 0) => {
      (nodes || []).forEach(n => {
        if (selectedSet.has(n.id)) return;
        out.push({ id: n.id, name: `${'  '.repeat(level)}${n.name}`, level });
        if (n.children && n.children.length) walk(n.children, level + 1);
      });
    };
    walk(folders, 0);
    return out;
  }, [folders, selectedSet]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!Array.isArray(selectedIds) || selectedIds.length === 0) {
      showError('Selecione ao menos uma pasta');
      return;
    }
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(getApiUrl('test-repository/folders/move'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          folder_ids: selectedIds,
          target_folder_id: targetFolderId || null
        })
      });
      if (res.ok) {
        showSuccess(selectedIds.length > 1 ? 'Pastas movidas com sucesso' : 'Pasta movida com sucesso');
        onSuccess && onSuccess();
        handleClose();
      } else {
        const err = await res.json().catch(() => ({}));
        showError(err.error || 'Erro ao mover pastas');
      }
    } catch (err) {
      console.error('Erro ao mover pastas:', err);
      showError('Erro ao mover pastas');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setTargetFolderId('');
    onClose && onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal">
        <div className="modal-header">
          <h2>Mover pastas selecionadas</h2>
          <button className="modal-close" onClick={handleClose}>✕</button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="form-group">
              <label>Destino</label>
              <select value={targetFolderId} onChange={(e) => setTargetFolderId(e.target.value)}>
                <option value="">Raiz do projeto (MAIN)</option>
                {flatFolders.map(f => (
                  <option key={f.id} value={f.id}>{f.name}</option>
                ))}
              </select>
            </div>
            <div className="hint">{selectedIds.length} pasta(s) selecionada(s)</div>
          </div>
          <div className="modal-actions">
            <button type="button" className="btn btn-secondary" onClick={handleClose}>Cancelar</button>
            <button type="submit" className="btn btn-primary" disabled={loading}>{loading ? 'Movendo...' : 'Mover'}</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default MoveFoldersModal;
